const statusCampos = {
  IdentificacaoPaciente: "IDENTIFICACAO_PACIENTE", LaudoImagem: "LAUDO_IMAGEM", EvolucaoMedico: "EVOLUCAO_MEDICO",
  CID: "CID", SolicitacaoExames: "SOLICITACAO_EXAMES", ProgramacaoDiagnostica: "PROGRAMACAO_DIAGNOSTICA"
};
const observacoes = { observacao: "OBSERVACAO", observacaoMembroONA: "OBSERVACAO_MEMBRO_ONA", observacaoMedicoAuditado: "OBSERVACAO_MEDICO_AUDITADO" };
const campos = { ...observacoes };
Object.entries(statusCampos).forEach(([local, campo]) => { campos["status" + local] = "STATUS_" + campo; campos["motivo" + local] = "MOTIVO_" + campo; });
const ligado = value => value === true || String(value) === "1";
const modo = vm => ligado(vm.podeComentarMembroONA) ? "ONA" : ligado(vm.podeComentarMedicoAuditado) ? "MEDICO" : "AUDITOR";
export const contextoAuditoria = vm => JSON.stringify([vm.$route.fullPath, vm.$route.params.id,
  vm.atendimento.ID_ATENDIMENTO, vm.atendimento.AUDITORIA?.ID_ATENDIMENTO_AUDITORIA, modo(vm)]);
export async function requisitarAuditoria(api, jwt, { consultar = false, dados }) {
  if(!jwt.getToken()) { throw Object.assign(new Error("Confira a sessão antes de salvar."), { antesDoEnvio: true }); }
  api.setHeader();
  const { data } = await api.postOnce("atendimentos/access/" + (consultar ? "consultarAuditoriaConfirmada" : "salvarAuditoriaConfirmada"), dados, { timeout: 120000 });
  return data;
}
export function auditoriaConfirmada(response, req) {
  return response?.contrato === "AUDITORIA_GRAVACAO_V1" && response.resultado === true && response.estado === "CONFIRMADO" &&
    ["ID_CLIENT_REQUEST", "ID_PACIENTE", "ID_ATENDIMENTO", "ID_ATENDIMENTO_AUDITORIA", "MODO"].every(k => String(response[k]) === String(req[k])) &&
    Object.entries(req.DADOS).every(([k, v]) => response.DADOS?.[k] === v);
}
const controls = new WeakMap();
export function auditoriaEditor(vm, uuid) {
  if(controls.has(vm)) { return controls.get(vm); }
  let pending = null, busy = false, destroyed = false, epoch = 0, baseline = {}, operation = null;
  const visible = () => vm.$refs.modalAuditoria?.showModal && vm.$refs.modalAuditoria?.showModalInside;
  const state = mensagem => { vm.isLoading = busy; vm.gravacaoAuditoria = { ocupada: busy, pendente: !!pending, mensagem }; };
  const valid = req => !destroyed && req.epoch === epoch && req.context === contextoAuditoria(vm) && visible();
  function reset() {
    baseline = { ...(vm.atendimento.AUDITORIA || {}) };
    for(const [local, campo] of Object.entries(campos)) { vm[local] = String(baseline[campo] ?? ""); }
    vm.eAuditor = modo(vm) === "AUDITOR";
  }
  async function send(req, consultar) {
    busy = true; operation = req; state(consultar ? "Consultando gravação…" : "Confirmando gravação…");
    try {
      let response;
      try { response = await vm.requisitarAuditoria({ consultar, dados: req.payload }); }
      catch(error) {
        if(valid(req) && error.antesDoEnvio && !consultar) { pending = null; state(error.message); return false; }
      }
      if(!valid(req)) { return false; }
      if(!consultar && response?.estado === "REJEITADO" && auditoriaConfirmada({ ...response, resultado: true, estado: "CONFIRMADO" }, req.payload)) {
        pending = null; state(response.mensagem || "Não foi possível iniciar a gravação. Seu preenchimento foi preservado."); return false;
      }
      if(!consultar && !auditoriaConfirmada(response, req.payload)) {
        try { response = await vm.requisitarAuditoria({ consultar: true, dados: req.payload }); } catch(error) { /* Manter a consulta disponível. */ }
      }
      if(!valid(req)) { return false; }
      if(!auditoriaConfirmada(response, req.payload)) {
        state("Gravação ainda não confirmada. Seu preenchimento foi preservado; consulte o resultado sem reenviar."); return false;
      }
      pending = null; state("");
      vm.$emit("auditado", { ...req.payload, ROTA: vm.$route.fullPath });
      vm.$swal({ icon: "success", title: "Auditoria salva com sucesso!", timer: 2000 });
      c.fechar(); return true;
    } finally {
      if(operation === req) {
        busy = false; operation = null; vm.isLoading = false;
        vm.gravacaoAuditoria.ocupada = false;
        if(pending && !valid(req)) { state("Há uma gravação sem confirmação. Consulte o resultado antes de editar novamente."); }
      }
    }
  }
  const c = {
    abrir() {
      if(destroyed || vm.$refs.modalAuditoria?.showModal) { return false; }
      if(!pending) { reset(); state(""); }
      vm.$refs.modalAuditoria.toggleModal(); return true;
    },
    fechar() { epoch++; if(visible()) { vm.$refs.modalAuditoria.fecharModalInterno(); } },
    fechado() { epoch++; },
    async salvar() {
      if(destroyed || busy || !visible()) { return false; }
      if(pending) { return c.consultar(); }
      const role = modo(vm), dados = {}, anterior = {};
      for(const [local, campo] of Object.entries(campos)) {
        const incluir = role === "ONA" ? campo === "OBSERVACAO_MEMBRO_ONA" : role === "MEDICO" ? campo === "OBSERVACAO_MEDICO_AUDITADO" : !["OBSERVACAO_MEMBRO_ONA", "OBSERVACAO_MEDICO_AUDITADO"].includes(campo);
        if(incluir) { dados[campo] = String(vm[local] ?? ""); anterior[campo] = String(baseline[campo] ?? ""); }
      }
      if(role === "AUDITOR") {
        for(const campo of Object.values(statusCampos)) {
          const status = dados["STATUS_" + campo], motivo = "MOTIVO_" + campo;
          if(!["Conforme", "Não conforme", "Não se aplica"].includes(status)) { state("Preencha todos os status da auditoria."); return false; }
          if(status === "Não conforme" && !dados[motivo].trim()) { state("Informe o motivo para cada item não conforme."); return false; }
          if(status !== "Não conforme") { dados[motivo] = ""; }
        }
      }
      const row = vm.atendimento, payload = { ID_CLIENT_REQUEST: uuid(), MODO: role, DADOS: dados, ANTERIOR: anterior,
        ID_PACIENTE: row.ID_PACIENTE || vm.$route.params.id, ID_ATENDIMENTO: row.ID_ATENDIMENTO, ID_ATENDIMENTO_AUDITORIA: row.AUDITORIA?.ID_ATENDIMENTO_AUDITORIA };
      if(![payload.ID_PACIENTE, payload.ID_ATENDIMENTO, payload.ID_ATENDIMENTO_AUDITORIA].every(v => /^[1-9]\d*$/.test(String(v))) || String(payload.ID_PACIENTE) !== String(vm.$route.params.id)) {
        state("Atualize o histórico para identificar a auditoria e o atendimento."); return false;
      }
      pending = { payload, context: contextoAuditoria(vm), epoch };
      return send(pending, false);
    },
    consultar() {
      if(destroyed || busy || !pending || !visible() || pending.context !== contextoAuditoria(vm)) { return Promise.resolve(false); }
      pending = { ...pending, epoch }; return send(pending, true);
    },
    invalidar() {
      c.fechar(); pending = null; busy = false; operation = null; baseline = {}; state("");
      for(const local of Object.keys(campos)) { vm[local] = ""; }
    },
    destruir() { c.invalidar(); destroyed = true; }
  };
  controls.set(vm, c); return c;
}
